import React, { Component } from "react";
import TrinityResultTableHeader from "./components/TrinityResultTableHeader";
import TrinityResultTableContent from "./components/TrinityResultTableContent";
import Line from "../../../../../components/Line";
import "./style.css";
class TrinityResultTable extends Component {
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  render() {
    const { result, height } = this.props;
    return (
      <div>
        <TrinityResultTableHeader></TrinityResultTableHeader>
        <div style={{ height: height }}></div>
        {result != null && result.length > 0 ? (
          <div>
            {result.map((item, index) => {
              return (
                <div key={index}>
                  <TrinityResultTableContent
                    result={item}
                  ></TrinityResultTableContent>
                  <Line></Line>
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
        <div style={{ height: "47px" }}></div>
      </div>
    );
  }
}

export default TrinityResultTable;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityResult/components/TrinityResultTable/index.js